module.exports = __webpack_public_path__ + "media/images/the-curve-logo-blk-bg-a7892f137708f00e3a96732a6a950f85.webp";